import { render, staticRenderFns } from "./SideSpace.vue?vue&type=template&id=10e7f53b&"
import script from "./SideSpace.vue?vue&type=script&lang=js&"
export * from "./SideSpace.vue?vue&type=script&lang=js&"
import style0 from "./SideSpace.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SideSpace.vue"
export default component.exports